import { render } from "./CentralRow.vue?vue&type=template&id=54c903dd"
import script from "./CentralRow.vue?vue&type=script&lang=js"
export * from "./CentralRow.vue?vue&type=script&lang=js"

import exportComponent from "/home/vshemyatin/phonebook/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__